import { css } from "@emotion/css";
import { CalendarDate } from "@internationalized/date";
import {
  DateRangePickerProps as AriaDateRangePickerProps,
  DateValue,
  RangeCalendar,
} from "react-aria-components";

import { _DateRangePicker } from "./assets/_DateRangePicker";
import { _Group } from "./assets/_Group";
import { DatePickerCalendar } from "./components/DatePickerCalendar";
import { DatePickerInput } from "./components/DatePickerInput";
import { DatePickerToggle } from "./components/DatePickerToggle";
import { useDatePickerStyles } from "./utils";
import { _Popover } from "../../_assets/_Popover";
import { Divider } from "../../divider/Divider";
import { _Dialog } from "../../modal/assets/_Dialog";
import {
  FieldErrors,
  FieldErrorsProps,
} from "../_assets/input-wrapper/FieldErrors";
import { FormLabelRAC } from "../_assets/input-wrapper/FormLabelRAC";

export interface DateRangePickerProps
  extends Omit<
    AriaDateRangePickerProps<any>,
    "minValue" | "maxValue" | "validate" | "className" | "style"
  > {
  label: string;
  errors?: FieldErrorsProps["children"];
  minValue?: CalendarDate;
  maxValue?: CalendarDate;
  isRequired?: boolean;
  testID: string;
  isStatic?: boolean;
}

export function DateRangePicker(props: DateRangePickerProps) {
  const {
    label,
    errors,
    minValue,
    maxValue,
    isRequired,
    testID,
    isStatic,
    ...rest
  } = props;
  const styles = useDatePickerStyles();

  return (
    <_DateRangePicker
      {...rest}
      className={css({
        gap: isStatic ? undefined : "var(--space-2)",
        alignItems: isStatic ? "center" : "initial",
      })}
      data-testid={testID}
      minValue={minValue as unknown as DateValue}
      maxValue={maxValue as unknown as DateValue}
    >
      <>
        {!isStatic && (
          <FormLabelRAC isRequired={isRequired}>{label}</FormLabelRAC>
        )}
        <div
          className={css({
            boxSizing: "border-box",
            width: isStatic ? "100%" : "293px",
            padding: isStatic ? "var(--space-3) var(--space-4)" : undefined,
          })}
        >
          <_Group isInvalid={!!errors}>
            <DatePickerInput slot="start" />
            <span aria-hidden="true">-</span>
            <DatePickerInput slot="end" />
            <DatePickerToggle
              isStatic={isStatic}
              isDisabled={props.isDisabled}
            />
          </_Group>
        </div>
        <FieldErrors>{errors}</FieldErrors>
        {isStatic ? (
          <>
            <Divider className={css({ width: "100%" })} />
            <RangeCalendar className={styles.calendar}>
              <DatePickerCalendar />
            </RangeCalendar>
          </>
        ) : (
          <_Popover className={styles.popover}>
            <_Dialog width="288">
              <RangeCalendar className={styles.calendar}>
                <DatePickerCalendar />
              </RangeCalendar>
            </_Dialog>
          </_Popover>
        )}
      </>
    </_DateRangePicker>
  );
}
